import { Box, Typography, Button, Container, Card, Divider } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Add, ArrowCircleRight, Diversity3, QrCode, QrCode2, QrCodeScanner,  FastForward} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import GenerateQRCode from "./QRCode/GenerateQRCode";
import { useState } from "react";
import { callPostApi } from "../API/ApiCallFunction";
import GradientLoader from "../CommanComponents/GradientLoader";
import { useEffect } from "react";
import cashipluslogo from "../../assets/cashidark.png";

function DashboardPlus() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [datar, setDatar] = useState({
    total_pending: 0,
    total_loaded: 0,
    total_active: 0,
    total_customer: 0,
   });
   const cashi_plus_flag = user.store_info.cashi_plus_flag;
  const dashbaordPlusApi = async () => {
    setLoading(true);
    const storeid = user.store_info.store_id;
    const payload = { mod: "CASHI_PLUS_DASHBOARD", data_arr: { store_id: storeid }, };  
    const apiResult = await callPostApi("cashi-dashboard", payload);
 
   if (apiResult.status === "200" && apiResult.data) {
     const item = apiResult.data;
     setDatar({
         total_pending: item.total_pending || 0,
         total_loaded: item.total_loaded || 0,
         total_active: item.total_active || 0,
         total_customer: item.total_customer || 0,
     });
     setLoading(false);
   } 
  else {
      setLoading(false);
    }
   };

  useEffect(() => {
    dashbaordPlusApi();
  }, []);
   

  return (
    <Box>
      <Box p={3}>
        <Container >
            <Box display="flex" justifyContent="space-between" flexWrap={"wrap"} >
              <Box display="flex" alignItems="center" >
                <Button sx={{background:'linear-gradient(195deg, #EC407A, #D81B60)', color:'#ffffff',
                    boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
                   }} onClick={()=> setOpen(true)}><Add/> Generate QR Coupons</Button>
                     <GenerateQRCode open={open} onClose={()=> setOpen(false)} />

                 <Button sx={{background:'linear-gradient(195deg, #42424a, #191919)', color:'#ffffff',ml:1,
                    boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
                   }} onClick={() => navigate('loadQR')}><QrCode2 sx={{mr:1}}/>QR Coupon List</Button>
                      <Button sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color:'#ffffff',ml:1,
              boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
               }} onClick={() => navigate('redeemed')}>Redeemed</Button>
              </Box>
              {cashi_plus_flag === "1" && (
              <Button onClick={() => navigate("/dashboard")}>
                <img
                  src={cashipluslogo}
                  alt="cashi plus"
                  style={{ height: "40px", width: "auto" }}
                />
              </Button>
            )}
             {/* <Button onClick={()=> navigate('redeemed')} sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color:'#ffffff',ml:1,
              boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
               }}> <LocalOffer sx={{mr:1}} /> Redeemed */}
             {/* </Button>  */}

             
            </Box>
           
            <Grid container rowSpacing={6} columnSpacing={2} my={6}>
              <Grid size={{ xs: 12,sm:12, md: 6,}} position="relative" sx={{boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px'}}>
               <Card className="dashcard" sx={{padding:'10px 15px', backgroundColor:'#ffffff', }} >
                <Grid container spacing={2}>
                 <Grid size={{ xs: 12, sm:6, md: 4,}}>
                   <Box className="icobox" sx={{background: 'linear-gradient(195deg, #42424a, #191919)'}}>
                    <QrCode sx={{fontSize:'38px', color:'#ffffff'}}/>
                   </Box>
                 </Grid>
                 <Grid size={{ xs: 12,sm:6, md: 8,}} sx={{mb:4}}>
                  <Typography variant="h6">Generated QR Coupons</Typography>
                  <Typography variant="h4" >{datar.total_pending}</Typography>
                </Grid>
              </Grid>
              <Box position="absolute" bottom="0px" left="0px" width="100%" sx={{ textAlign:'center'}}>
                <Divider sx={{borderColor:'#6c757d;'}} />
                <Button sx={{fontWeight:'600'}} onClick={() => navigate('generatedQR')}>View More 
                  <ArrowCircleRight sx={{fontSize:'20px', marginLeft:"8px", marginBottom:'3px'}} /> </Button>
              </Box>
             </Card>
           </Grid>
          <Grid size={{ xs: 12,sm:12, md: 6}} position="relative" sx={{boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px'}}>
            <Card className="dashcard" sx={{padding:'10px 15px', }} >
             <Grid container spacing={2}>
              <Grid size={{ xs: 12,sm:6, md: 4,}}>
               <Box className="icobox"  variant="gradient" color="#30325E" sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)'}}>
                 <FastForward sx={{fontSize:'38px', color:'#ffffff'}} />
               </Box>
              </Grid>
              <Grid size={{ xs: 12,sm:6, md: 8,}} sx={{mb:4}}>
                 <Typography variant="h6">Loaded QR Coupons</Typography>
                <Typography variant="h4">{datar.total_loaded}</Typography>
              </Grid>
            </Grid>
            <Box position="absolute" bottom="0px" left="0px" width="100%" sx={{ textAlign:'center'}}>
               <Divider sx={{borderColor:'#6c757d;'}} />
                <Button sx={{fontWeight:'600'}} onClick={() => navigate('loadedQR')} >
                  View More <ArrowCircleRight sx={{fontSize:'20px', marginLeft:"8px", marginBottom:'3px'}} /> </Button>
            </Box>
           </Card>
          </Grid>
          <Grid size={{ xs: 12,sm:12, md: 6}} position="relative" sx={{boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px'}}>
            <Card className="dashcard" sx={{padding:'10px 15px', }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12,sm:6, md: 4,}}>
                 <Box className="icobox" sx={{background:'linear-gradient(195deg, #66BB6A, #43A047)'}}>
                    <QrCodeScanner sx={{fontSize:'38px', color:'#ffffff'}}/>
                 </Box>
               </Grid>
              <Grid size={{ xs: 12,sm:6, md: 8,}} sx={{mb:4}}>
                 <Typography variant="h6">Activated QR Coupons</Typography>
                 <Typography variant="h4">{datar.total_active}</Typography>
               </Grid>
             </Grid>
             <Box position="absolute" bottom="0px" left="0px" width="100%" sx={{ textAlign:'center'}}>
                <Divider sx={{borderColor:'#6c757d;'}} />
                <Button sx={{fontWeight:'600'}} onClick={() => navigate('activatedQR')}>
                  View More <ArrowCircleRight sx={{fontSize:'20px', marginLeft:"8px", marginBottom:'3px'}} /> </Button>
              </Box>
            </Card>
            </Grid>

            <Grid size={{ xs: 12,sm:12, md: 6}} position="relative" sx={{boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px'}}>
              <Card className="dashcard" sx={{padding:'10px 15px', }}>
                <Grid container spacing={2}>
                 <Grid size={{ xs: 12,sm:6, md: 4,}}>
                  <Box className="icobox" sx={{background: 'linear-gradient(195deg, #EC407A, #D81B60)'}}>
                    <Diversity3 sx={{fontSize:'38px', color:'#ffffff'}} />
                  </Box>
                </Grid>
                <Grid size={{ xs: 12,sm:6, md: 8,}} sx={{mb:4}}>
                 <Typography variant="h6">Total Customers</Typography>
                 <Typography variant="h4">{datar.total_customer}</Typography>
                </Grid>
              </Grid>
             </Card>
             <Box position="absolute" bottom="0px" left="0px" width="100%" sx={{ textAlign:'center'}}>
                <Divider sx={{borderColor:'#6c757d;'}} />
                <Button sx={{fontWeight:'600'}} onClick={() => navigate('TotalPlusCustomer')}
                >View More <ArrowCircleRight sx={{fontSize:'20px', marginLeft:"8px", marginBottom:'3px'}} /> </Button>
            </Box>
           </Grid> 
          </Grid>
        </Container>
      </Box>
     {loading && <GradientLoader text="Loading" />}
    </Box>
  );
}


export default DashboardPlus;
